module.exports = __webpack_public_path__ + "static/img/Parametric Studies 3 - Plots.018666b.png";